import { Grid, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

import { COLORS } from '../../../configs/colors';
import { Typography } from '../../atoms/Typography';

export const MicroText = styled(Typography)`
  font-size: 10px;
  font-weight: bold;
  color: ${COLORS.DarkGray};
`;

export const StyledStack = styled(Stack)`
  width: 100%;
`;

export const SearchItemMainGrid = styled(Grid)`
  display: flex;
  flex: 1;
  flex-direction: row;
`;

export const LogoImageGrid = styled(Grid)`
  display: flex;
  width: 40px;
  height: 40px;
  margin-right: 10px;
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
  font-size: 14px;
`;

export const IconWrapper = styled('img')`
  width: 40px;
  height: 40px;
`;

export const SearchItemContentGrid = styled(Grid)`
  display: flex;
  flex: 1;
  flex-direction: column;
`;